import React from "react";
import PropTypes from 'prop-types';
import cx from 'classnames';

import './custom-arrows.scss';

function LeftArrow() {
    return (
        <svg width="17" height="28" viewBox="0 0 17 28" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
		    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
		        <g transform="translate(-295.000000, -124.000000)" fill="#FFFFFF">
		            <g transform="translate(309.142136, 138.142136) scale(-1, 1) rotate(-315.000000) translate(-309.142136, -138.142136) translate(299.142136, 128.142136)">
		                <rect x="2.27373675e-13" y="1.13686838e-13" width="19.5226344" height="3.48769053"></rect>
		                <polygon points="16.4683385 19.3866021 16.4683385 0.553073235 19.956029 0.553073235 19.956029 19.3866021"></polygon>
		            </g>
		        </g>
		    </g>
		</svg>
    )

}

function RightArrow(){
	return(
		<svg width="17" height="28" viewBox="0 0 17 28" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
		    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
		        <g transform="translate(-391.000000, -124.000000)" fill="#FFFFFF">
		            <g transform="translate(394.142136, 138.142136) rotate(-315.000000) translate(-394.142136, -138.142136) translate(384.142136, 128.142136)">
		                <rect x="-2.27373675e-13" y="-1.13686838e-13" width="19.5226344" height="3.48769053"></rect>
		                <polygon points="16.4683385 19.3866021 16.4683385 0.553073235 19.956029 0.553073235 19.956029 19.3866021"></polygon>
		            </g>
		        </g>
		    </g>
		</svg>
	)
}

function NextArrow(props) {
    const { className, onClick } = props;
    let mtvClassName = cx({
    	"mtv-slick-arrow": true
    })

    mtvClassName += ` ${className}`;
    return (
        <div
      className={mtvClassName} 
      onClick={onClick}
    ><RightArrow /></div>
    );
}
NextArrow.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func
}

NextArrow.defaultProps = {
    className: "",
    onClick: () => {}
}

function PrevArrow(props) {
    const { className, onClick } = props;
    let mtvClassName = cx({
    	"mtv-slick-arrow": true
    })

    mtvClassName += ` ${className}`;
    return (
        <div
      className={mtvClassName} 
      onClick={onClick}
    ><LeftArrow /></div>
    );
}
PrevArrow.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func
}

PrevArrow.defaultProps = {
    className: "",
    onClick: () => {}
}
export { NextArrow }
export { PrevArrow }